import React, { useState } from 'react';

import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { snapCenterToCursor } from '@dnd-kit/modifiers';
import styled from '@emotion/styled';
import { Image } from '@mui/icons-material';
import { useAtomValue } from 'jotai';
import { useHistory, useParams } from 'react-router';

import { selectedVisitAtom } from '../../../../app/appHeader/imageViewerMenu/atoms';
import { mixpanelEvents, useTrackEvent } from '../../../../utils/mixpanel';
import { annotateActionAtom } from '../atoms';

const DraggingImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
  height: 60px;
  background-color: black;
  color: white;
`;

export const DragAndDrop = ({ children }: { children: React.ReactNode }) => {
  const history = useHistory();
  const { trackEvent } = useTrackEvent();

  const { id: patientId, imageId: activeImage } = useParams<{
    id: string;
    imageId?: string;
  }>();

  const [activeImageBeingDragged, setActiveImageBeingDragged] = useState<{
    id: string | number;
    container: string;
  }>();

  const estimatedVisitId = useAtomValue(selectedVisitAtom);
  const annotate = useAtomValue(annotateActionAtom);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  const handleDragEnd = async () => {
    if (
      !activeImageBeingDragged?.id ||
      activeImage === activeImageBeingDragged?.id.toString() ||
      annotate
    ) {
      return;
    }

    trackEvent(mixpanelEvents.casePresentationSideBySide, {
      activeImage,
      selectedImage: activeImageBeingDragged.id,
      estimatedVisitId: estimatedVisitId,
      patientId,
    });

    const queryParams = new URLSearchParams({
      'selected-photo': activeImageBeingDragged.id.toString(),
    });
    history.replace({ search: queryParams.toString() });

    return;
  };

  return (
    <DndContext
      onDragEnd={handleDragEnd}
      onDragStart={(dragEvent) => {
        setActiveImageBeingDragged({
          id: dragEvent.active.id,
          container: dragEvent.active.id.toString(),
        });
      }}
      sensors={sensors}
    >
      {children}
      {!annotate && (
        <DragOverlay zIndex={1300} modifiers={[snapCenterToCursor]}>
          {!!activeImageBeingDragged && (
            <DraggingImage>
              <Image />
            </DraggingImage>
          )}
        </DragOverlay>
      )}
    </DndContext>
  );
};
